module.exports = __webpack_public_path__ + "img/2_17.fb2a4f27.png";